import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { checkPermission, isAssetDefaultDashboard, updateBreadCrumpData } from "../../../config/utils";
import { setPendingAction, triggerUnsavedChangesPrompt } from "../actions";
import { navigateWithPrompts } from "../../../utils/navigationHelpers";
import { DASHBOARD_MENU_PERMISSION, getAssetDashboardBreadCrumb } from "./DashboardSwitcher";

class BreadCrumbs extends Component {
    state = {
        breadCrumbsData: JSON.parse(sessionStorage.getItem("bc-data")) || []
    };

    componentDidMount() {
        window.addEventListener("bc-data-changed", this.handleStorageChange);
    }

    componentWillUnmount() {
        window.removeEventListener("bc-data-changed", this.handleStorageChange);
    }

    handleStorageChange = e => {
        this.setState({
            breadCrumbsData: JSON.parse(sessionStorage.getItem("bc-data")) || []
        });
    };

    handleBreadCrumpsClick = async breadCrumbData => {
        const { isFormDirty } = this.props;

        const action = async () => {
            await updateBreadCrumpData(breadCrumbData.index);

            const newData = JSON.parse(sessionStorage.getItem("bc-data")) || [];
            this.setState({ breadCrumbsData: newData });

            if (breadCrumbData.path) {
                this.props.history.push(breadCrumbData.path);
            }
        };

        navigateWithPrompts({
            isFormDirty: isFormDirty,
            navigateAction: action
        });
    };
    handleDashboardClick = () => {
        const { isFormDirty } = this.props;
        navigateWithPrompts({
            isFormDirty: isFormDirty,
            navigateAction: () => {
                const canSeeDashboards = checkPermission("menu", DASHBOARD_MENU_PERMISSION, null);
                const preferAsset = isAssetDefaultDashboard() && canSeeDashboards && checkPermission("charts_and_graph", "assets", "view");
                if (!preferAsset && canSeeDashboards && checkPermission("charts_and_graph", "dashboard", "view")) {
                    this.props.history.push("/dashboard");
                    sessionStorage.setItem(
                        "bc-data",
                        JSON.stringify([
                            {
                                key: "dashboard",
                                name: "Dashboard",
                                path: "/dashboard",
                                index: 0
                            }
                        ])
                    );
                } else {
                    const assetCrumb = getAssetDashboardBreadCrumb();
                    this.props.history.push(assetCrumb.path);
                    sessionStorage.setItem("bc-data", JSON.stringify([assetCrumb]));
                }
            }
        });
    };

    render() {
        const { breadCrumbsData } = this.state;
        const mainEntities = ["sites", "recommendations", "buildings", "floors", "regions", "clients", "consultancies", "documents"];
        const hasDashboardInBreadCrumbs =
            (breadCrumbsData || [])?.some(item => item?.key === "dashboard") || (breadCrumbsData || [])?.some(item => item?.key === "assetDashboard");
        return (
            <React.Fragment>
                <ul className="bread-crumb pl-0">
                    {!hasDashboardInBreadCrumbs ? (
                        <li
                            className="cursor-pointer bread-crumb-dashboard-home ml-1"
                            onClick={() => {
                                this.handleDashboardClick();
                            }}
                        >
                            <span className={"main-entity dshb-menu"}>
                                <i className="fa fa-home home-icon-badge"></i>
                                {/* <span className="home-label">Dashboard</span> */}
                            </span>
                            {breadCrumbsData && breadCrumbsData.length ? <i className="fas fa-chevron-right"></i> : null}
                        </li>
                    ) : null}
                    {breadCrumbsData && breadCrumbsData.length
                        ? breadCrumbsData.map((item, i) => {
                              const isLast = i === breadCrumbsData.length - 1;
                              return (
                                  <li
                                      className={isLast ? "active cursor-pointer" : "cursor-pointer"}
                                      key={i}
                                      onClick={() => {
                                          if (!item?.disabled) this.handleBreadCrumpsClick(item);
                                      }}
                                  >
                                      <span
                                          className={
                                              item.key === "dashboard" || item.key === "assetDashboard"
                                                  ? "main-entity dshb-menu"
                                                  : item.key === "main" || mainEntities.includes(item.name && item.name.toLowerCase())
                                                    ? "main-entity"
                                                    : !isLast && breadCrumbsData[breadCrumbsData.length - 2] === breadCrumbsData[i]
                                                      ? "border-active active-col"
                                                      : ""
                                          }
                                      >
                                          {item.key === "dashboard" || item.key === "assetDashboard" ? (
                                              <>
                                                  <i className="fa fa-home home-icon-badge"></i>
                                                  <span className="home-label">{item.name}</span>
                                              </>
                                          ) : (
                                              item.name
                                          )}
                                      </span>
                                      {!isLast && <i className="fas fa-chevron-right"></i>}
                                  </li>
                              );
                          })
                        : null}
                </ul>
            </React.Fragment>
        );
    }
}

const mapDispatchToProps = {
    setPendingAction,
    triggerUnsavedChangesPrompt
};
const mapStateToProps = state => {
    const {
        commonReducer: { isFormDirty }
    } = state;
    return { isFormDirty };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BreadCrumbs));
